import React, { useCallback } from 'react';

import { dashboardHref } from 'helpers/dashboardSession';
import { useObservability } from 'helpers/observability';
import { navTransactionLabel, useNavTransactions } from 'helpers/useNavTransactions';

import { MenuLinkItem } from '../components/MenuLinkItem';

interface MobileMenuAccountItemsProps {
  slug: string;
}

const isDashboardPath = (slug: string): boolean => {
  const normalizedSlug = slug.replace(/^\/+/, '');
  return normalizedSlug === 'dashboard' || normalizedSlug.startsWith('dashboard/');
};

/**
 * Mobile account items: Dashboard, active transactions, and Account settings.
 * Rendered inside the account section of {@link MobileMenuList}.
 */
export const MobileMenuAccountItemsV2: React.FC<MobileMenuAccountItemsProps> = ({ slug }) => {
  const { trackEvent } = useObservability();
  const transactions = useNavTransactions();

  // TODO: remove categoryOverride
  // observability is initialized with 'cosmos' as the category for all events
  const trackCtaClick = useCallback(
    (target: string) =>
      trackEvent('cta-click', target, undefined, { categoryOverride: 'homepage' }),
    [trackEvent],
  );

  return (
    <>
      <MenuLinkItem
        key="dashboard"
        href={dashboardHref('mobile_menu')}
        name="Dashboard"
        analyticsName="cosmos-mobile-nav-dashboard"
        isActive={isDashboardPath(slug)}
        onPress={() => trackCtaClick('dashboard-link')}
      />
      {transactions.map((transaction) => (
        <MenuLinkItem
          key={transaction.id}
          href={transaction.href}
          name={navTransactionLabel(transaction)}
          analyticsName={`cosmos-mobile-nav-${transaction.type}`}
          isActive={false}
        />
      ))}
      <MenuLinkItem
        key="account"
        href="/account"
        name="Account settings"
        analyticsName=""
        isActive={slug === '/account'}
        isLast
        onPress={() => trackCtaClick('account-link')}
      />
    </>
  );
};
